import React, { ReactNode } from "react";

import {
  Modal as MaterialUiModal,
  Button,
  Zoom,
  Typography
} from "@material-ui/core";

import { ModalProps, ModalAction } from "./types";
import useStyles from "./styles";

const Modal = ({ open, title, children, actions, className }: ModalProps) => {
  const styles = useStyles();

  const renderActionButton = (action: ModalAction, index: number) => {
    let disabled = false;
    if (action.disable) {
      disabled = action.disable();
    }

    return (
      <Button
        key={index}
        variant={
          action.variant || action.type === "ok" ? "contained" : "outlined"
        }
        color={action.color || action.type === "ok" ? "primary" : "secondary"}
        disabled={disabled}
        startIcon={action.startIcon}
        endIcon={action.endIcon}
        onClick={action.action}
        className={action.type === "ok" ? styles.okButton : styles.cancelButton}
      >
        {action.text}
      </Button>
    );
  };

  const renderActionButtons = () =>
    actions.map((action, index) =>
      action?.type !== "component"
        ? renderActionButton(action as ModalAction, index)
        : action?.component
    );

  return (
    <MaterialUiModal open={open} className={styles.modal}>
      <Zoom in={open}>
        <div className={`${styles.container} ${className}`}>
          <Typography component="div">
            <h2 className={styles.titleWrapper}>{title}</h2>

            <div className={styles.contentWrapper}>{children}</div>

            <div className={styles.actionsWrapper}>{renderActionButtons()}</div>
          </Typography>
        </div>
      </Zoom>
    </MaterialUiModal>
  );
};

export default Modal;
